import { render, staticRenderFns } from "./ZhanhuiYearStatBlock.vue?vue&type=template&id=573a4610&scoped=true"
import script from "./ZhanhuiYearStatBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiYearStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiYearStatBlock.vue?vue&type=style&index=0&id=573a4610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573a4610",
  null
  
)

export default component.exports